import FetchWrapper from '@mv-submodules/inplant-coreadapter-fe/functions/fetch-wrapper'

export const API = () => FetchWrapper.getInstance('plantAnalysis')
export const APIModel = () => FetchWrapper.getInstance('model')
export const APITitech = () => FetchWrapper.getInstance('titech')
export const APIHalts = () => FetchWrapper.getInstance('plantHalts')
export const APITest = () => FetchWrapper.getInstance('paTest')
export const APIPlantAnalysis = () => FetchWrapper.getInstance('plantAnalysisAPI')
export const PlantAnalysisGW = () => FetchWrapper.getInstance('plantAnalysisGW')
